import { createContext, useContext } from 'react';

/** Acima dos modais do ERP (z-50, z-[60], z-[70]) e do Alert (z-100). */
export const Z_TUTORIAL = 1000;

export const TutorialContext = createContext(null);

export const useTutorial = () => {
  const contexto = useContext(TutorialContext);
  if (!contexto) throw new Error('useTutorial precisa estar dentro de <TutorialProvider>');
  return contexto;
};
